import React, {useState} from 'react';
import {
  Box,
  BoxProps,
  Text,
  useToast,
  Tooltip,
  Editable,
  EditablePreview,
  EditableInput,
} from '@chakra-ui/react';
import {useMarketFromContext} from '../MarketProvider';
import {usePublishMarket} from '../../../hooks/api/markets';

export const EditableMarketLabel = ({...boxProps}: BoxProps) => {
  const market = useMarketFromContext();
  const publishMarket = usePublishMarket();
  const toast = useToast();

  const [marketLabel, setMarketLabel] = useState(market.label);

  const handleSubmit = (newLabel: string) => {
    const trimmed = newLabel.trim();
    if (!trimmed || trimmed === market.label) {
      setMarketLabel(market.label);
      return;
    }

    // ensure display value matches trimmed value
    setMarketLabel(trimmed);

    publishMarket.mutate(
      {marketId: market.id, label: trimmed},
      {
        onSuccess: () => {
          toast({
            title: 'Market name updated',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        },
        onError: () => {
          setMarketLabel(market.label);
        },
      }
    );
  };

  return (
    // minW needed for ellipsis truncation
    <Box minW={0} {...boxProps}>
      <Editable
        value={marketLabel}
        onChange={setMarketLabel}
        onSubmit={handleSubmit}
        isDisabled={publishMarket.isPending}
        submitOnBlur
        selectAllOnFocus
      >
        <Tooltip label="Click to edit" hasArrow openDelay={500}>
          <EditablePreview
            as={Text}
            cursor="text"
            _hover={{opacity: 0.7}}
            noOfLines={1}
            sx={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          />
        </Tooltip>

        <EditableInput px={0} minW="100px" />
      </Editable>
    </Box>
  );
};
